// extracted by css-extract-rspack-plugin
export default {"editor":"AceEditor-module__editor___A3jPJ"};